import { render, staticRenderFns } from "./UpdatedCard.vue?vue&type=template&id=20a98ae0&scoped=true&"
import script from "./UpdatedCard.vue?vue&type=script&lang=js&"
export * from "./UpdatedCard.vue?vue&type=script&lang=js&"
import style0 from "./UpdatedCard.vue?vue&type=style&index=0&id=20a98ae0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a98ae0",
  null
  
)

export default component.exports